export default "__VITE_ASSET__25SZAZg0__"